module.exports = __webpack_public_path__ + "static/media/loading-white.37483420.svg";